import styled from 'styled-components';
import { Text } from '@comicrelief/component-library';

const UnstyledFieldset = styled.fieldset`
  border: 0;
  padding: 0;
  margin: 0 ;
`;

const UnstyledLegend = styled.legend`
  padding: 0;
  margin: 0;
`;

const FieldsetSectionHeading = styled(Text)`
  // No overrides needed any more; just keeping styles clean and consistency
`;

const FieldsetFirstChild = styled.div`
  margin-bottom: 30px;
`;

export {
  UnstyledFieldset,
  UnstyledLegend,
  FieldsetSectionHeading,
  FieldsetFirstChild
};
